import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'orderby',
  standalone: true,
})
export class OrderByPipe implements PipeTransform {
  transform(value: any[], order: 'asc' | 'desc' = 'asc'): any[] {
    return value.sort((a, b) => {
      if (order === 'asc') {
        return a.order - b.order
      } else if (order === 'desc') {
        return b.order - a.order
      }
      return 0
    })
  }
}
